var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.693 2.43433H16.6058C16.0208 2.43432 15.4416 2.54954 14.9011 2.7734C14.3606 2.99727 13.8696 3.32539 13.4559 3.73904L3.73891 13.4559C2.90354 14.2913 2.43422 15.4244 2.4342 16.6058V60.1515C2.4342 62.2681 4.16595 64 6.2827 64H43.6941C45.8101 64 47.5414 62.2688 47.5414 60.1528V6.2827C47.5414 4.16608 45.8096 2.43433 43.693 2.43433Z",
    fill: "url(#paint0_linear_291_4327)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2587 1.07814e-10H14.1716C13.5866 -4.06971e-06 13.0074 0.115214 12.4669 0.339077C11.9264 0.56294 11.4354 0.891062 11.0217 1.30471L1.30471 11.0217C0.469333 11.8571 1.93505e-05 12.9902 0 14.1716V57.7173C0 59.834 1.73175 61.5658 3.8485 61.5658H41.2599C43.3759 61.5658 45.1072 59.8346 45.1072 57.7186V3.8485C45.1072 1.73175 43.3753 1.07814e-10 41.2587 1.07814e-10Z",
    fill: "url(#paint1_linear_291_4327)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8694 40.4833H14.845C14.5274 40.4833 14.2229 40.3571 13.9983 40.1326C13.7737 39.908 13.6476 39.6034 13.6476 39.2859V36.891C13.6476 36.5734 13.7737 36.2689 13.9983 36.0443C14.2229 35.8198 14.5274 35.6936 14.845 35.6936H23.8694C24.187 35.6936 24.4916 35.8198 24.7161 36.0443C24.9407 36.2689 25.0668 36.5734 25.0668 36.891V39.2859C25.0668 39.6034 24.9407 39.908 24.7161 40.1326C24.4916 40.3571 24.187 40.4833 23.8694 40.4833ZM37.4897 40.4833H28.9619C28.6443 40.4833 28.3397 40.3571 28.1152 40.1326C27.8906 39.908 27.7645 39.6034 27.7645 39.2859V36.891C27.7645 36.5734 27.8906 36.2689 28.1152 36.0443C28.3397 35.8198 28.6443 35.6936 28.9619 35.6936H37.4897C37.8073 35.6936 38.1119 35.8198 38.3365 36.0443C38.561 36.2689 38.6872 36.5734 38.6872 36.891V39.2859C38.6872 39.9472 38.151 40.4833 37.4897 40.4833ZM32.8567 47.6973H37.4896C37.8072 47.6973 38.1118 47.5711 38.3363 47.3465C38.5609 47.122 38.687 46.8174 38.687 46.4998V44.105C38.687 43.7874 38.5609 43.4829 38.3363 43.2583C38.1118 43.0338 37.8072 42.9076 37.4896 42.9076H32.8567C32.5391 42.9076 32.2346 43.0338 32.01 43.2583C31.7854 43.4829 31.6593 43.7874 31.6593 44.105V46.4998C31.6593 47.1612 32.1955 47.6973 32.8567 47.6973ZM14.845 47.6973H27.7643C28.0819 47.6973 28.3865 47.5711 28.611 47.3465C28.8356 47.122 28.9618 46.8174 28.9618 46.4998V44.105C28.9618 43.7874 28.8356 43.4829 28.611 43.2583C28.3865 43.0338 28.0819 42.9076 27.7643 42.9076H14.845C14.5274 42.9076 14.2229 43.0338 13.9983 43.2583C13.7737 43.4829 13.6476 43.7874 13.6476 44.105V46.4998C13.6477 47.1612 14.1838 47.6973 14.845 47.6973ZM23.8694 54.9111H14.845C14.5274 54.9111 14.2229 54.785 13.9983 54.5604C13.7737 54.3359 13.6476 54.0313 13.6476 53.7137V51.319C13.6476 51.0014 13.7737 50.6969 13.9983 50.4723C14.2229 50.2477 14.5274 50.1216 14.845 50.1216H23.8694C24.187 50.1216 24.4916 50.2477 24.7161 50.4723C24.9407 50.6969 25.0668 51.0014 25.0668 51.319V53.7138C25.0668 54.375 24.5307 54.9111 23.8694 54.9111ZM37.4897 54.9111H28.9619C28.6443 54.9111 28.3397 54.785 28.1152 54.5604C27.8906 54.3359 27.7645 54.0313 27.7645 53.7137V51.319C27.7645 51.0014 27.8906 50.6969 28.1152 50.4723C28.3397 50.2477 28.6443 50.1216 28.9619 50.1216H37.4897C37.8073 50.1216 38.1119 50.2477 38.3365 50.4723C38.561 50.6969 38.6872 51.0014 38.6872 51.319V53.7138C38.6872 54.375 38.151 54.9111 37.4897 54.9111Z",
    fill: "#45B14A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84561 40.544C10.185 40.544 11.2708 39.4582 11.2708 38.1188C11.2708 36.7794 10.185 35.6936 8.84561 35.6936C7.50621 35.6936 6.42041 36.7794 6.42041 38.1188C6.42041 39.4582 7.50621 40.544 8.84561 40.544Z",
    fill: "#45B14A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84561 47.727C10.185 47.727 11.2708 46.6412 11.2708 45.3018C11.2708 43.9624 10.185 42.8766 8.84561 42.8766C7.50621 42.8766 6.42041 43.9624 6.42041 45.3018C6.42041 46.6412 7.50621 47.727 8.84561 47.727Z",
    fill: "#45B14A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84561 54.9112C10.185 54.9112 11.2708 53.8254 11.2708 52.486C11.2708 51.1466 10.185 50.0608 8.84561 50.0608C7.50621 50.0608 6.42041 51.1466 6.42041 52.486C6.42041 53.8254 7.50621 54.9112 8.84561 54.9112Z",
    fill: "#45B14A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132054 13.0909C0.117749 13.1528 0.104698 13.213 0.0926514 13.2711H11.8805C12.7151 13.2711 13.3917 12.5945 13.3917 11.7599V0.0701904C13.2996 0.0866295 13.2027 0.105829 13.103 0.127915C12.2242 0.322298 11.4231 0.774058 10.7867 1.41041L1.41242 10.7847C0.778044 11.4183 0.334407 12.2174 0.132054 13.0909Z",
    fill: "url(#paint2_linear_291_4327)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5537 31.0473C28.5684 31.0473 33.4444 26.1713 33.4444 20.1566C33.4444 14.1418 28.5684 9.26587 22.5537 9.26587C16.5389 9.26587 11.663 14.1418 11.663 20.1566C11.663 26.1713 16.5389 31.0473 22.5537 31.0473Z",
    fill: "url(#paint3_linear_291_4327)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4109 20.7598C33.2202 23.2293 32.2054 25.4678 30.6404 27.2013C29.8436 28.0842 28.9083 28.8314 27.8712 29.4134L21.2626 22.804L19.1704 20.7119C18.1487 19.7921 17.6326 18.4595 17.6326 16.9765C17.6326 14.201 19.756 12.0784 22.5313 12.0784C24.0143 12.0784 25.3469 12.5938 26.2667 13.6156L33.4109 20.7598Z",
    fill: "url(#paint4_linear_291_4327)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.64 27.2012C29.8432 28.0841 28.9079 28.8313 27.8708 29.4134C26.2983 30.2951 24.4842 30.7973 22.5531 30.7973C21.9178 30.7976 21.2837 30.7426 20.6579 30.6329L16.3973 26.3723C16.0664 26.1815 16.081 25.7139 16.3641 25.3997L16.3724 25.3914C17.6501 23.9722 19.3156 23.0739 21.262 22.804C21.6823 22.7463 22.1059 22.7175 22.5301 22.718C24.9288 22.718 27.0918 23.5893 28.631 25.1924L30.64 27.2012Z",
    fill: "url(#paint5_linear_291_4327)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.536 22.2523C25.3114 22.2523 27.5613 20.0024 27.5613 17.227C27.5613 14.4516 25.3114 12.2017 22.536 12.2017C19.7605 12.2017 17.5106 14.4516 17.5106 17.227C17.5106 20.0024 19.7605 22.2523 22.536 22.2523Z",
    fill: "url(#paint6_linear_291_4327)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8629 25.6883C28.8319 25.6533 28.8006 25.6187 28.7691 25.5842C27.2232 23.8982 25.0035 22.8419 22.5353 22.8419C20.0403 22.8419 17.7976 23.9225 16.2503 25.6415L16.2425 25.6501C15.8949 26.0359 16.1429 26.6533 16.6595 26.7047C18.1991 26.8582 20.3722 26.9534 22.7814 26.9534C24.9578 26.9534 26.9416 26.8756 28.4399 26.7473C28.963 26.7025 29.2116 26.0808 28.8629 25.6883Z",
    fill: "url(#paint7_linear_291_4327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291_4327",
    x1: 13.4756,
    y1: 17.4354,
    x2: 49.9321,
    y2: 67.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45B14A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291_4327",
    x1: 0,
    y1: 0,
    x2: 45.1072,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291_4327",
    x1: 0.0926514,
    y1: 0.0701904,
    x2: 13.3917,
    y2: 0.0701904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_291_4327",
    x1: 18.1124,
    y1: 15.7153,
    x2: 29.0862,
    y2: 26.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4F4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_291_4327",
    x1: 17.6326,
    y1: 12.0784,
    x2: 33.4109,
    y2: 12.0784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43765A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_291_4327",
    x1: 16.1504,
    y1: 22.718,
    x2: 30.64,
    y2: 22.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43765A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_291_4327",
    x1: 20.0055,
    y1: 17.227,
    x2: 24.3963,
    y2: 17.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_291_4327",
    x1: 16.0811,
    y1: 22.8419,
    x2: 29.0247,
    y2: 22.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.390b50d246ba1587462c5b4482f36189.svg";
export { ForwardRef as ReactComponent };